import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import Reveal from "@/components/Reveal";
import SectionHeader from "@/components/SectionHeader";

const FAQS = [
  {
    q: "Do you clean apartments?",
    a: "Yes, we provide cleaning services for apartments and residential properties.",
  },
  {
    q: "Do you clean offices?",
    a: "Yes, we offer commercial cleaning for offices and other businesses.",
  },
  {
    q: "Do you offer deep cleaning?",
    a: "Yes, deep cleaning is available for homes, apartments, and other properties.",
  },
  {
    q: "Do you offer recurring cleaning?",
    a: "Yes, customers can schedule weekly, biweekly, or monthly cleaning.",
  },
  {
    q: "How do I get a price?",
    a: "Contact us or complete the quote form. Final pricing depends on the size and condition of the property and the services requested.",
  },
];

const FAQ = () => (
  <section id="faq" className="bg-[#F9F9F9] py-20 sm:py-24" data-testid="faq-section">
    <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
      <SectionHeader align="center" eyebrow="Good to Know" title="Frequently Asked Questions" />
      <Reveal className="mt-12">
        <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-2xl border border-[#8E7CC3]/15 bg-white px-6 shadow-[0_8px_30px_rgb(0,0,0,0.03)]"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="py-5 text-left text-base font-medium text-[#2C2A35] hover:text-[#674EA7] hover:no-underline [&[data-state=open]>svg]:text-[#D4AF37]" data-testid={`faq-question-${i}`}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-sm leading-relaxed text-[#6B6776] sm:text-base" data-testid={`faq-answer-${i}`}>
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default FAQ;
